import { Component, CUSTOM_ELEMENTS_SCHEMA, Input } from '@angular/core';
import { environment } from '@env/environment';
import { RcLoaderSize } from '@rc-df/ds-web-components';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class LoaderComponent {
  @Input() transparent = false;
  @Input() withinContent = false;
  @Input() size: RcLoaderSize = 'large';

  public readonly isStandalone = environment.isStandalone;
}
